import { render, staticRenderFns } from "./smallMap2.vue?vue&type=template&id=29d942ba&scoped=true"
import script from "./smallMap2.vue?vue&type=script&lang=js"
export * from "./smallMap2.vue?vue&type=script&lang=js"
import style0 from "./smallMap2.vue?vue&type=style&index=0&id=29d942ba&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29d942ba",
  null
  
)

export default component.exports